import { STATUS_META, PRIORITY_META } from "../lib/constants";

export function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.open;
  return (
    <span data-testid={testid || "ticket-status-badge"} className={`beacon-badge ${m.bg} ${m.text} ${m.border}`}>
      <span className={`beacon-dot ${m.dot}`} />
      {m.label}
    </span>
  );
}

export function PriorityBadge({ priority, testid }) {
  const m = PRIORITY_META[priority] || PRIORITY_META.medium;
  return (
    <span data-testid={testid || "ticket-priority-badge"} className={`beacon-badge ${m.bg} ${m.text} ${m.border}`}>
      <span className={`beacon-dot ${m.indicator}`} />
      {m.label}
    </span>
  );
}
